const organizationReducer = (
  state = {
    id: "",
    teams: [],
    designations: [],
    showDeactivationAlert: false,
    expirationDate: "",
    paymentStatus: true,
    validTill:"",
    organizationData:{},
    showMigratedBucket: false,
    lockSideNavbar: false,
    hasActiveWAPackage: null,
    WAAgentActiveStatus: "",
    accessAllowedMarketingAutomation: null
  },
  action: {
    type:
      | "SET_ORGANIZATION"
      | "SET_ID"
      | "UPDATE_TEAMS"
      | "UPDATE_DESIGNATIONS"
      | "SET_DEACTIVATION_ALERT"
      | "SET_PAYMENT_STATUS"
      | "SET_ORGANIZATION_DATA"
      | "SET_SHOW_MIGRATED_BUCKET"
      | "SET_LOCK_SIDE_NAVBAR"
      | "SET_HAS_ACTIVE_WA_PACKAGE"
      | "SET_WA_AGENT_ACTIVE_STATUS"
      | "SET_ACCESS_MARKETING_AUTOMATION_STATUS"
    payload: any;
  }
) => {
  switch (action.type) {
    case "SET_ORGANIZATION":
      return { ...state, ...action.payload };
    case "SET_ID":
      return { ...state, id: action.payload };
    case "UPDATE_TEAMS":
      return { ...state, teams: [...state.teams, action.payload] };
    case "UPDATE_DESIGNATIONS":
      return {
        ...state,
        designations: [...state.designations, action.payload],
      };
    case "SET_DEACTIVATION_ALERT":
      return {
        ...state,
        showDeactivationAlert: action.payload.showAlert,
        expirationDate: action.payload.expirationDate,
        validTill: action.payload.validTill,
    };
    case "SET_PAYMENT_STATUS":
      return {
        ...state,
        paymentStatus: action.payload.paymentStatus
    };
    case "SET_ORGANIZATION_DATA":
      return {
        ...state,
        organizationData: action.payload.organizationData
    };
    case "SET_SHOW_MIGRATED_BUCKET":
      return {
        ...state,
        showMigratedBucket: action.payload.showMigratedBucket
    };
    case "SET_LOCK_SIDE_NAVBAR":
      return {
        ...state,
        lockSideNavbar: action.payload.lockSideNavbar
    };
    case "SET_HAS_ACTIVE_WA_PACKAGE":
      return {
        ...state,
        hasActiveWAPackage: action.payload.hasActiveWAPackage
    };
    case "SET_WA_AGENT_ACTIVE_STATUS":
      return {
        ...state,
        WAAgentActiveStatus: action.payload.WAAgentActiveStatus
    };
    case "SET_ACCESS_MARKETING_AUTOMATION_STATUS":
      return {
        ...state,
        accessAllowedMarketingAutomation: action.payload.accessAllowedMarketingAutomation
    };
    default:
      return state;
  }
};

export default organizationReducer;
